
import { AlertTriangle, CheckCircle } from "lucide-react";
import { SubscriptionStatus } from "@/services/subscription";

interface SubscriptionHeaderProps {
  subscriptionStatus: SubscriptionStatus | null;
  formatSubscriptionType: (type: string) => string;
}

export const SubscriptionHeader = ({ subscriptionStatus, formatSubscriptionType }: SubscriptionHeaderProps) => {
  return (
    <div className="bg-secondary/30 p-4 rounded-lg">
      <div className="flex items-start gap-3">
        {subscriptionStatus?.isActive ? (
          <CheckCircle className="h-5 w-5 text-green-500 mt-0.5 shrink-0" />
        ) : (
          <AlertTriangle className="h-5 w-5 text-amber-500 mt-0.5 shrink-0" />
        )}
        <div>
          <h3 className="font-medium mb-1">Current Plan: {formatSubscriptionType(subscriptionStatus?.subscriptionType || 'none')}</h3>
          <p className="text-sm text-muted-foreground">
            {subscriptionStatus?.isActive ? (
              "You have an active subscription with unlimited recipe transformations."
            ) : subscriptionStatus?.remainingFreeTransforms ? (
              `You have ${subscriptionStatus.remainingFreeTransforms} free recipe transformations remaining.`
            ) : (
              "You've used all your free transformations. Upgrade to continue transforming recipes."
            )}
          </p>
        </div>
      </div>
    </div>
  );
};
